// extracted by mini-css-extract-plugin
export default {"frame":"frame-fSMJ"};